<template>
  <div>
    <div class="question-rating" v-for="(v, k) in loop" :key="k">
      <div class="question">{{ removeBB(v) }}</div>

      <div class="bar">
        <div class="inner-bar" :style="{ width: `${percentage(k)}%` }">
          <div class="start-rating"></div>
          <div class="end-rating"></div>
        </div>
      </div>

      <div class="info">{{ answer(k).count }} ({{ percentageStr(k) }}%)</div>
    </div>
  </div>
</template>

<script>
import ReportingQuestionMixin from '@/app/mixins/ReportingQuestionMixin';

export default {
  name: 'RatingScale',

  mixins: [ReportingQuestionMixin],

  methods: {
    removeBB(v) {
      return v.replace('[br]', ' ');
    },
  },
};
</script>

<style lang="scss" scoped>
.question-rating {
  display: grid;
  grid-template-areas:
    'question question'
    'bar info';
  grid-template-columns: 1fr 100px;
  grid-template-rows: auto auto;
  column-gap: 15px;
  row-gap: 7px;
  min-height: 35px;
  margin: 10px 0;

  .question {
    grid-area: question;
    margin: auto 0;
  }

  .bar {
    grid-area: bar;
    position: relative;
    width: 100%;
    background-color: #d5d7d8;
    border-radius: 1000px;
    padding: 4px;
    margin: auto;
    max-height: 20px;
    height: 20px;

    .inner-bar {
      position: relative;
      min-height: 14px;
      max-width: 100%;
      min-width: 18px;
      height: 100%;
      border-radius: 1000px;
      transition: width 0.25s ease-in-out;
      background-color: #3a87a3;

      .start-rating,
      .end-rating {
        position: absolute;
        transform: translateY(-3px);
        border-radius: 10000000px;
        height: 18px;
        width: 18px;
        border: 1px solid #fff;
        background-color: #3a87a3;
      }

      .end-rating {
        right: 0;
      }
    }
  }
}
</style>
